<template>
    <div class="container_wrap">
        <div class="content_title">{{catedetailDataArr.name}}</div>
        <div class="content_date">发布日期：{{catedetailDataArr.update_time|timeFormat}}</div>
        <div class="content_container html-data" v-html="catedetailDataArr.content"></div>
    </div>    
</template>
<script>
export default {
    name:"CateSinglePage",
    data(){
        return {
            catedetailDataArr:[]
        }
    },
    mounted(){
        this.getCateDetailFun(this.$route.query.id)
    },
    methods:{
        getCateDetailFun(id){
            var that = this;
      that.$api.get(
        "/api/cms/cateListItem",
        {
          id: id,
        },
        (res) => {
            if(res.data[0].tpl!='CateSinglePage'){
                return;
            }
        //   this.$message.success(res.data[0].name+"  获取成功");
          that.catedetailDataArr = res.data[0];
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
        }
    },
    watch:{
        $route:{
            handler(){
                this.getCateDetailFun(this.$route.query.id)
            },
            deep:true
        }
    }
}
</script>
<style lang="scss" scoped>
.container_wrap{
    width: 1240px;
    margin: 0 auto;
    min-height: calc(100vh - 446px);
    overflow: hidden;
}
.content_title{
    width: 100%;
    text-align: center;
    margin-top: 15px;
    font-size: 22px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.content_date{
    width: 100%;
    text-align: center;
    font-size: 16px;
    margin-top: 5px;
    color: #9B9B9B;
    margin-bottom: 5px;
}
</style>


// WEBPACK FOOTER //
// CateSinglePage.vue?2afa11c4